import { render } from "./App.vue?vue&type=template&id=c0a58a04&scoped=true"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=c0a58a04&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\wy2204\\bamboo\\argus-energy\\argus-energy\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c0a58a04"]])

export default __exports__